<template>
<AdminPanelEpicentrkMegogoCodes />
</template>

<script>
import AdminPanelEpicentrkMegogoCodes from '../components/AdminPanelEpicentrkMegogoCodes.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEpicentrkMegogoCodes
    },
    methods: {},
    mounted() {}
}
</script>
